import {
  FETCH_CUSTOMER_AVAILABLE_PRODUCTS_FAILED,
  FETCH_CUSTOMER_AVAILABLE_PRODUCTS_SUCCESS,
  FETCH_CUSTOMER_BUNDLE_USAGES_FAILED,
  FETCH_CUSTOMER_BUNDLE_USAGES_SUCCESS,
  SET_PRODUCTS,
  SET_PRODUCTS_FAILED,
  PRODUCT_SAVE_FAILED,
  FETCH_CUSTOMER_ACTIVE_PURCHASES_SUCCESS,
  FETCH_CUSTOMER_ACTIVE_PURCHASES_FAILED,
  FETCH_CUSTOMER_ACTIVE_PURCHASES_START,
  FETCH_CUSTOMER_AVAILABLE_PRODUCTS_START,
  FETCH_FILTERED_PRODUCT_NOT_ADDONS_SUCCESS,
  CREATE_PURCHASE_START,
  CREATE_PURCHASE_SUCCESS,
  CREATE_PURCHASE_FAILED,
  DELETE_RECORD_SUCCESS,
  PRODUCT_UPDATE_FAILED,
  PRODUCT_SAVE_STARTED,
  FETCH_FILTERED_PRODUCT_BUNDLES_SUCCESS,
  FETCH_FILTERED_PRODUCT_LICENSE_BUNDLES_SUCCESS,
  SET_PRODUCT_OPTIONS
} from "../actions/types";

export default (state = {}, action) => {
  switch (action.type) {
    case SET_PRODUCTS:
      return {
        ...state,
        products: action.products,
        error: false
      };
    case SET_PRODUCT_OPTIONS: {
      return { ...state, productOptions: action.products, error: false };
    }
    case SET_PRODUCTS_FAILED:
      return {
        ...state,
        products: null,
        error: true,
        errors: action.errors
      };
    case PRODUCT_SAVE_FAILED:
    case PRODUCT_UPDATE_FAILED:
      return {
        ...state,
        error: true,
        apiErrors: action.errors
      };
    case PRODUCT_SAVE_STARTED:
    case "@@router/LOCATION_CHANGE":
      return {
        errors: false,
        apiErrors: null
      };
    case CREATE_PURCHASE_START:
    case FETCH_CUSTOMER_ACTIVE_PURCHASES_START:
    case FETCH_CUSTOMER_AVAILABLE_PRODUCTS_START:
      return { ...state, inProgress: true };
    case FETCH_CUSTOMER_ACTIVE_PURCHASES_SUCCESS:
      return {
        ...state,
        customerActiveProducts: {
          list: action.payload.products,
          productMetadataItems: action.payload.productMetadataItems,
          productMetadataTypes: action.payload.productMetadataTypes,
          productBundles: action.payload.productBundles,
          productLicenseBundles: action.payload.productLicenseBundles,
          bundles: action.payload.bundles,
          licenseBundles: action.payload.licenseBundles,
          productPrices: action.payload.productPrices
        },
        inProgress: false
      };
    case FETCH_FILTERED_PRODUCT_BUNDLES_SUCCESS: {
      return {
        ...state,
        ...action.payload
      };
    }
    case FETCH_FILTERED_PRODUCT_LICENSE_BUNDLES_SUCCESS: {
      return {
        ...state,
        ...action.payload
      };
    }
    case FETCH_FILTERED_PRODUCT_NOT_ADDONS_SUCCESS: {
      return {
        ...state,
        notAddOns: action.payload.products
      };
    }
    case FETCH_CUSTOMER_BUNDLE_USAGES_SUCCESS:
      return {
        ...state,
        bundleUsages: action.payload.bundleUsages
      };
    case FETCH_CUSTOMER_BUNDLE_USAGES_FAILED:
      return {
        ...state,
        bundleUsages: {}
      };
    case FETCH_CUSTOMER_AVAILABLE_PRODUCTS_SUCCESS:
      return {
        ...state,
        customerAvailableProducts: {
          list: action.payload.products,
          productMetadataItems: action.payload.productMetadataItems,
          productMetadataTypes: action.payload.productMetadataTypes,
          productBundles: action.payload.productBundles,
          productLicenseBundles: action.payload.productLicenseBundles,
          bundles: action.payload.bundles,
          licenseBundles: action.payload.licenseBundles,
          productPrices: action.payload.productPrices
        },
        inProgress: false
      };
    case FETCH_CUSTOMER_ACTIVE_PURCHASES_FAILED:
      return {
        ...state,
        customerActiveProducts: {}
      };
    case FETCH_CUSTOMER_AVAILABLE_PRODUCTS_FAILED:
      return {
        ...state,
        customerAvailableProducts: {}
      };
    case CREATE_PURCHASE_SUCCESS:
    case CREATE_PURCHASE_FAILED:
      return { ...state, inProgress: false };
    case DELETE_RECORD_SUCCESS:
      if (action.resource === "products" && action.apiVersion === "v1") {
        const {
          products: { products, ...rest1 },
          ...rest
        } = state;

        const { [action.recordSlug]: removedValue, ...rest2 } = products;

        const newState = { ...rest, products: { products: { ...rest2 }, ...rest1 } };

        return newState;
      } else {
        return state;
      }
    default:
      return state;
  }
};
